<template>
    <div class="curtain-grey">
        <CategoryInfo v-if="categoryInfoState"
                      :categoryItem="currentCategory"
                      @closeEvent="switchCategoryInfo"
                      @submitEvent="saveCategoryInfo($event)"/>
        <CategoryDelete v-if="categoryDeleteState"
                @closeEvent="switchCategoryDelete"
                @submitEvent="saveCategoryDelete($event)"/>
        <div class="body-category" v-show="!categoryInfoState && !categoryDeleteState">
            <div class="border-category">
                <div class="row-title">
                    <div class="title-tip">支持拖动排序</div>
                    <div class="icon-close my-cursor" @click="close()"></div>
                    <div class="text-title">分类管理</div>
                </div>
                <ul ref="category-items" class="category-items scrollbar"
                    @dragstart="dragStart($event)"
                    @dragenter="dragEnter($event)"
                    @dragover="dragOver($event)"
                    @dragend="dragEnd($event)">
                    <li ref="category-item" class="category-item" draggable="true"
                        v-for="(item) in tbListCategory" :data-index="item.sortNum">
                        <div class="icon-move"></div>
                        <div class="text-category">{{ item.title }}</div>
                        <div class="icon-update my-cursor" @click.stop="openCategoryInfo(item)"></div>
                        <div class="icon-delete my-cursor" @click.stop="openDeleteCategory(item)"></div>
                    </li>
                </ul>
                <div class="category-create my-cursor" @click="openCategoryInfo({})">
                    <img src="../../../assets/images/List/icon-create.png" class="icon" alt="">
                    新建分类
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CategoryInfo from "@/pages/List/CategoryManage/CategoryInfo";
import CategoryDelete from "@/pages/List/CategoryManage/CategoryDelete";
import { mapState, mapMutations } from "vuex";
export default {
    name: "CategoryManage",
    components: {
        CategoryInfo,
        CategoryDelete
    },
    data(){
        return {
            categoryInfoState: false,
            categoryDeleteState: false,
            currentLi: {},
            currentCategory: {},
        }
    },
    computed: {
        ...mapState(["userId"]),
        ...mapState("listModules", {
            tbListCategory: state => state.tbListCategory,
            tbListInfo: state => state.tbListInfo,
            optId: state => state.optId,
        }),
    },
    methods: {
        ...mapMutations("listModules", ["setLoading", "setOptId", "setCategory", "setList", "setDeleteData"]),
        close: function(){
            this.$emit("closeEvent");
            this.saveSortCategory();
        },

        switchCategoryInfo: function(){
            this.categoryInfoState = !this.categoryInfoState;
        },
        switchCategoryDelete: function(){
            this.categoryDeleteState = !this.categoryDeleteState;
        },
        /**
         * 打开分类信息
         */
        openCategoryInfo: function(item){
            this.currentCategory = item;
            this.switchCategoryInfo();
        },
        /**
         * 打开删除弹窗
         */
        openDeleteCategory: function(item){
            this.currentCategory = item;
            this.switchCategoryDelete();
        },
        /**
         * 保存分类信息
         */
        saveCategoryInfo: function(e){
            const listCategoryList = [];
            const listInfoList = [];
            if(this.currentCategory.categoryId){
                // 修改
                this.currentCategory.title = e;
                this.currentCategory.dataAction = "update";
            }else{
                // 创建
                let sortNum = 0;
                if(this.tbListCategory.length > 0){
                    sortNum = this.tbListCategory[0].sortNum + 10;
                }
                this.currentCategory.categoryId = this.$Utils.get_uuid();
                this.currentCategory.userId = this.userId;
                this.currentCategory.title = e;
                this.currentCategory.sortNum = sortNum;
                this.currentCategory.createTimeStamp = Date.now();
                this.currentCategory.dataAction = "add";
            }
            listCategoryList.push(this.currentCategory);

            this.tbListInfo.forEach((item)=>{
                if(item.categoryId === this.currentCategory.categoryId){
                    item.categoryTitle = e;
                    item.dataAction = "update";
                    listInfoList.push(item);
                }
            });
            this.sendRequest(listInfoList, listCategoryList, []);
        },
        /**
         * 删除分类信息
         */
        saveCategoryDelete: function(){
            const listInfoList = [];


            this.tbListInfo.forEach((item)=>{
                if(item.categoryId === this.currentCategory.categoryId){
                    item.categoryId = "";
                    item.categoryTitle = "";
                    item.dataAction = "update";
                    listInfoList.push(item);
                }
            })
            const listDeleteList = [{
                deleteType: "inventory_category",
                deleteDataId: this.currentCategory.categoryId
            }]
            this.sendRequest(listInfoList, [], listDeleteList);
        },
        /**
         * 保存 分类排序
         */
        saveSortCategory: function(){
            const items = this.$refs["category-items"].childNodes;
            const listCategoryList = [];

            items.forEach((item, index)=>{
                if(item.nodeName !== "LI"){
                    return
                }
                const itemIndex = parseInt(item.getAttribute("data-index"));

                const categoryItem = this.tbListCategory[index];

                if(itemIndex !== categoryItem.sortNum){
                    categoryItem.sortNum = itemIndex;
                    categoryItem.dataAction = "update";
                    listCategoryList.push(categoryItem);
                }
            })
            if(listCategoryList.length >0){

                this.sendRequest([], listCategoryList, []);
            }

        },
        sendRequest: function(listInfoList, listCategoryList, listDeleteList){
            const that = this;
            const params = {
                optId: this.optId,
                listInfoList: listInfoList,
                listClockList: [],
                listCategoryList: listCategoryList,
                listChildList: [],
                listTimeLineList: [],
                listDeleteList: listDeleteList,
            }
            this.setLoading(true);
            this.$api.getSyncList(params).then((res)=>{
                that.setLoading(false);
                if(res.data.code === 200 && !res.data.data.differenceData){
                    that.setList(listInfoList);
                    that.setCategory(listCategoryList);
                    that.setDeleteData(listDeleteList);

                    that.setOptId(res.data.data.lastOptId);
                }else{
                    that.$PopupToast("保存失败");
                }
            })
        },
        dragStart: function(e){
            let target = e.target;
            window.getSelection().removeAllRanges();
            if(target.tagName === "DIV"){
                target = target.parentNode;
            }else if(!target.tagName){
                target = target.parentNode.parentNode
            }
            this.currentLi = target;
            setTimeout(()=>{
                this.currentLi.classList.add('category-item-moving');
            })
        },
        dragEnter: function(e){
            e.preventDefault();
            let target = e.target;
            if(target.tagName === "DIV"){
                target = target.parentNode
            }
            const currentList = this.$refs["category-items"];
            if(target === this.currentLi|| target === currentList){
                return
            }

            let liArray = Array.from(currentList.childNodes);
            let currentIndex = liArray.indexOf(this.currentLi);
            let targetIndex = liArray.indexOf(target);
            if(targetIndex === 0 || targetIndex === -1){
                return
            }
            if(currentIndex < targetIndex){
                currentList.insertBefore(this.currentLi,target.nextElementSibling)
            }else{
                currentList.insertBefore(this.currentLi,target)
            }
        },
        dragOver: function(e){
            e.preventDefault()
        },
        dragEnd: function (){
            this.currentLi.classList.remove('category-item-moving');
        },

    },

}
</script>

<style scoped>

div.body-category{
    width: 4.72rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-category{
    width: 100%;
    height: auto;
    padding: 0.2rem 0 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.row-title{
    width: 100%;
    height: 0.26rem;
    position: relative;
}
div.text-title{
    width: 100%;
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.26rem;
    text-align: center;
    position: absolute;
    z-index: 1;
}
div.title-tip{
    font-size: 0.15rem;
    color: #000000;
    line-height: 0.2rem;
    text-align: left;
    margin-top: 0.06rem;
    margin-left: 2.9rem;
    float: left;
    position: relative;
    z-index: 2;
}
div.icon-close{
    width: 0.24rem;
    height: 0.24rem;
    margin-top: 0.02rem;
    background: url("../../../assets/images/Public/icon-close.png") no-repeat;
    background-size: cover;
    float: right;
    margin-right: 0.11rem;
    position: relative;
    z-index: 2;
}

ul.category-items{
    width: 100%;
    max-height: 2.64rem;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    padding: 0.16rem 0.1rem;
    box-sizing: border-box;
    overflow: auto;
}
ul.scrollbar{
    padding-right: 0.1rem;
    overflow-y: scroll;
}
ul.scrollbar::-webkit-scrollbar{
    background: transparent;
}

li.category-item{
    width: 100%;
    height: 0.52rem;
    margin-bottom: 0.12rem;
    border: 0.02rem solid #000000;
    border-radius: 0.1rem;
    box-sizing: border-box;

    display: flex;
    align-items: center;

    padding: 0 0.2rem;
}

li.category-item-moving{
    opacity: 0.5;
}

div.icon-move{
    width: 0.19rem;
    height: 0.16rem;
    background: url("../../../assets/images/List/icon-move.png") no-repeat;
    background-size: cover;
    cursor: move;

}
div.text-category{
    flex: 1;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: left;
    margin: 0 0.1rem;
}
div.icon-update{
    width: 0.24rem;
    height: 0.24rem;
    background: url("../../../assets/images/List/icon-update.png") no-repeat;
    background-size: cover;
    margin-right: 0.2rem;
}
div.icon-delete{
    width: 0.24rem;
    height: 0.24rem;
    background: url("../../../assets/images/List/icon-delete.png") no-repeat;
    background-size: cover;
}


div.category-create{
    width: 4.24rem;
    height: 0.52rem;
    background-color: #FEE494;
    border: 0.02rem solid #000000;
    border-radius: 0.1rem;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.05rem;
}
div.category-create img{
    width: 0.16rem;
    height: 0.16rem;
    display: block;

}
</style>
